import Boundary from "./Boundary";

export {Boundary};
export {default as CatchError} from "./CatchError";

export default {
    Boundary
};
